import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Index.vue'
import Login from '../views/Login.vue'
import publicIndex from '../views/public/index.vue'





Vue.use(VueRouter)

// 重写路由的push方法，解决相同路由跳转 报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/login',
    name: 'Login',
    meta: {
      requireAuth: false, //表示进入这个路由需要登录
    },
    component: Login,

  },
  {
    path: '/',
    name: 'Index',
    meta: {
      requireAuth: true, //表示进入这个路由需要登录
    },
    redirect: '/homeoverview',
    // component: () => import(/* webpackChunkName: "index" */ '../views/Index.vue'),
    component: Index,
    children: [
      { path: '/homeoverview', name: 'HomeOverview', component: () => import( '../components/HomeOverview.vue'), meta: { requireAuth: true }, },
      { path: '/usermanage', name: 'UserManage', component: () => import('../components/UserManage.vue'), meta: { requireAuth: true }, },
      { path: '/warningsettings', name: 'WarningSettings', component: () => import('../components/WarningSettings.vue'), meta: { requireAuth: true }, },
      {
        path: '/enterprisesearch', name: 'EnterpriseSearch', component: () => import('../components/EnterpriseSearch.vue'), meta: { requireAuth: true }
      },
      // { path: '/keycompanies', name: 'KeyCompanies', component: () => import('../components/KeyCompanies.vue'), meta: { requireAuth: true }, },
      { path: '/patentssearch', name: 'PatentsSearch', component: () => import('../components/PatentsSearch.vue'), meta: { requireAuth: true, keepAlive:true },
    },
      { path: '/patentanalysis', name: 'PatentAnalysis', component: () => import('../components/PatentAnalysis.vue'), meta: { requireAuth: true }, },
      { path: '/trademarksearch', name: 'TrademarkSearch', component: () => import('../components/TrademarkSearch.vue'), meta: { requireAuth: true },},
      { path: '/trademarkanalysis', name: 'TrademarkAnalysis', component: () => import('../components/TrademarkAnalysis.vue'), meta: { requireAuth: true }, },
      { path: '/renewalalertpt', name: 'RenewalAlertpt', component: () => import('../components/RenewalAlertpt.vue'), meta: { requireAuth: true }, },
      { path: '/renewalalerttm', name: 'RenewalAlerttm', component: () => import( '../components/RenewalAlerttm.vue'), meta: { requireAuth: true }, },
      { path: '/keyindustries', name: 'KeyIndustries', component: () => import('../components/KeyIndustries.vue'), meta: { requireAuth: true }, },
      { path: '/KeyCompanies', name: 'KeyCompanies', component: () => import('../components/KeyCompanies.vue'), meta: { requireAuth: true }, },
      { path: '/geoproducts', name: 'GeoProducts', component: () => import('../components/GeoProducts.vue'), meta: { requireAuth: true }, },
      { path: '/geotrademark', name: 'GeoTrademark', component: () => import( '../components/GeoTrademark.vue'), meta: { requireAuth: true }, },
   
      { path: '/ReportDetail', name: 'ReportDetail', component: () => import('../components/ReportDetail.vue'), meta: { requireAuth: true }, },
      // { path: '/IntegratedDiagram', name: 'IntegratedDiagram', component: () => import('../components/IntegratedDiagram.vue'), meta: { requireAuth: true }, },
      { path: '/ReportManagement', name: 'ReportManagement', component: () => import('../components/ReportManagement.vue'), meta: { requireAuth: true }, },
      { path: '/EnterpriseInfo', name: 'EnterpriseInfo', component: () => import( '../components/EnterpriseInfo.vue'), meta: { requireAuth: true }, },
      { path: '/TrademarkInfo', name: 'TrademarkInfo', component: () => import('../components/TrademarkInfo.vue'), meta: { requireAuth: true }, },
      { path: '/PatentSearchInfo', name: 'PatentSearchInfo', component: () => import('../components/PatentSearchInfo.vue'), meta: { requireAuth: true }, },
      { path: '/serviceAdvice', name: 'serviceAdvice', component: () => import('../components/serviceAdvice.vue'), meta: { requireAuth: true }, },
    ]
  },
// 公共服务平台
{
  path: '/public',
  name: 'public',
  meta: {
    requireAuth: false, 
  },
  redirect: '/home',
  // component: () => import(/* webpackChunkName: "index" */ '../views/Index.vue'),
  component: publicIndex,
  children: [
    { path: '/home', name: 'publicHome', component: () => import( '../views/public/components/home.vue')},
    { path: '/advice', name: 'publicAdvice', component: () => import('../views/public/components/advice.vue')},
    { path: '/article', name: 'publicArticle', component: () => import('../views/public/components/article.vue')},
    { path: '/callUs', name: 'publicCallUs', component: () => import('../views/public/components/callUs.vue')},
  ]
},
]

const router = new VueRouter({
  routes
})

export default router
